export default {
	UNKNOWN: "unknown",
	WEB: "web",
	MOBILEWEB: "mobileWeb",
	IOS: "ios",
	ANDROID: "android",
};
